namespace $ {
	$mol_test_mocks.push( $=> {
		class $giper_baza_mine_mock extends $.$giper_baza_mine_temp {}
		$.$giper_baza_mine = $giper_baza_mine_mock
	} )
}
